tower.autoLoadProjects = ->
  return unless getAutoLoad().length > 0

  showSpinner()

  $.ajax
    url: location.href
    data: { page: nextPageNumber() }
    method: 'get'
    dataType: 'json'
  .done (data, status, xhr) ->
    hideSpinner()
    if xhr.status != HTTP_STATUS_NO_CONTENT and data.html.trim().length > 0
      $projects = $(data.html)
      $projects.hide().appendTo $('.projects')
      tower.updateProjectsSortable $('.projects')
      group = tower.getCurrentProjectGroup()
      unless group is 'stars'
        tower.filterProjectsHelper $('.projects'), group
      setCurrentPageNumber data.page
      if data.is_last_page
        getAutoLoad().remove()
        removeSpinner()
        tower.filterInitProject group
      else
        tower.autoLoadProjects()

tower.isAutoLoadProjectsCompleted = ->
  $('#page-projects #auto-load-more').length > 0

tower.updateProjectsSortable = ($el) ->
  $el.sortable
    items: '.project:not(.new-project-placeholder)'
    cursor: 'pointer'
    distance: 20
    revert: 100
    tolerance: 'pointer'
    placeholder: 'project-placeholder'
    start: (e, ui) ->
      simple.popover.destroyAll()
    update: (e, ui) ->
      updateProjectSequence ui.item

getAutoLoad = () ->
  $('#page-projects #auto-load-more')

showSpinner = () ->
  $spinner =
    if $('.projects').find('.spinner')[0]
      $('.projects').find('.spinner').first()
    else
      $('<div class="spinner"><i class="twr twr-refresh twr-spin"></i></div>')
  $spinner.appendTo($('.projects')).fadeIn(250)

hideSpinner = () ->
  $spinner = $('.projects').find('.spinner').fadeOut(250)

removeSpinner = () ->
  $('.projects').find('.spinner').remove()

updateProjectSequence = (project) ->
  accessId = project.data('access-id')
  prevAccessId = project.prev('.project').data('access-id')
  nextAccessId = project.next('.project').data('access-id')
  $.ajax
    url: '/teams/' + tower.team.guid + '/projects/reorder/'
    type: 'post'
    dataType: 'json'
    data:
      access_id: accessId
      prev_access_id: prevAccessId
      next_access_id: nextAccessId

setCurrentPageNumber = (pageNumber) ->
  $('#page-projects #auto-load-more').data 'page-number', pageNumber

nextPageNumber = ->
  Number($('#page-projects #auto-load-more').data('page-number') or 1) + 1

